import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { Checkbox, FormControlLabel, FormGroup, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { INK } from "../../../theme/tokens";
import type { ManagementCenterChartKey } from "../utlis";

interface GraphsSelectorProps {
	visibleCharts: ManagementCenterChartKey[];
	onVisibleChartsChange: (visible: ManagementCenterChartKey[]) => void;
}

const CHART_OPTIONS: { id: ManagementCenterChartKey; label: string }[] = [
	{ id: "ppdComparison", label: "PPD Comparison" },
	{ id: "hppdComparison", label: "HPPD Comparison" },
	{ id: "staffSatisfaction", label: "Staff Satisfaction" },
	{ id: "shiftFillRate", label: "Shift Fill Rate" },
	{ id: "otUse", label: "OT Use" },
	{ id: "agencyUse", label: "Agency Use" },
	{ id: "weekActiveUsers", label: "Weekly Active Users" },
];

export const GraphsSelector = ({ visibleCharts, onVisibleChartsChange }: GraphsSelectorProps) => {
	const [settingsAnchorEl, setSettingsAnchorEl] = useState<null | HTMLElement>(null);

	const isSettingsOpen = Boolean(settingsAnchorEl);

	const handleToggleChart = (chartId: ManagementCenterChartKey) => {
		if (visibleCharts.includes(chartId)) {
			onVisibleChartsChange(visibleCharts.filter((id) => id !== chartId));
		} else {
			onVisibleChartsChange([...visibleCharts, chartId]);
		}
	};

	const handleOpenSettings = (event: React.MouseEvent<HTMLButtonElement>) => {
		setSettingsAnchorEl(event.currentTarget);
	};

	const handleCloseSettings = () => {
		setSettingsAnchorEl(null);
	};

	return (
		<>
			<IconButton onClick={handleOpenSettings} size="small" sx={{ color: INK.SECONDARY }}>
				<SettingsIcon />
			</IconButton>
			<Menu anchorEl={settingsAnchorEl} open={isSettingsOpen} onClose={handleCloseSettings}>
				<MenuItem disableRipple disableTouchRipple>
					<Typography sx={{ fontWeight: 500, fontSize: 14 }}>Graphs visibility</Typography>
				</MenuItem>
				<FormGroup sx={{ px: 2, py: 1 }}>
					{CHART_OPTIONS.map((option) => (
						<FormControlLabel
							key={option.id}
							control={<Checkbox checked={visibleCharts.includes(option.id)} onChange={() => handleToggleChart(option.id)} size="small" />}
							label={option.label}
						/>
					))}
				</FormGroup>
			</Menu>
		</>
	);
};
